// extracted by mini-css-extract-plugin
module.exports = {"root":"Analogs_root__powDq","pagination":"Analogs_pagination__-Y2d1"};